module.exports = __webpack_public_path__ + "static/media/Placeholder.47b9e82a.png";